<template>
  <el-form ref="zcform" :model="form" :rules="rules" label-width="160px">
    <el-form-item label="姓名：" prop="contactName">
      <el-input
        clearable
        v-model.trim="form.contactName"
        class="input-long"
        placeholder="请输入姓名"
        maxlength="50"
      />
    </el-form-item>
    <el-form-item label="手机号：" prop="phone">
      <div style="display: flex; align-items: center">
        <el-input
          clearable
          v-model.trim="form.phone"
          class="input-long"
          placeholder="请输入手机号后续将作为会员登录账号"
          maxlength="11"
        />

        <div
          style="font-family: PingFangSC"
          :class="
            isPhoneBtnClick
              ? 'phoneBtn phoneBtn-click'
              : 'phoneBtn phoneBtn-default'
          "
          @click="getTestCode"
        >
          {{ isPhoneBtnClick ? phoneBtnTxt + "秒" : phoneBtnTxt }}

          <div class="islider" v-if="isCode">
            <Slider
              @close="isCode = false"
              :log="true"
              @getImg="getImg"
              @validImg="validImg"
            ></Slider>
          </div>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="验证码：" prop="authCode">
      <el-input
        clearable
        v-model.trim="form.authCode"
        class="input-long"
        placeholder="请输入验证码"
        maxlength="8"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import { getSendMsg, getImageVerifyCode } from "@/api/register-shop";
import Slider from "@/views/common/slider.vue";

import validators from "@/utils/validators";
export default {
  components: {
    Slider,
  },
  data() {
    return {
      phoneBtnTxt: "发送验证码",
      isPhoneBtnClick: false,
      isCode: false,
      form: {
        contactName: "", //注册联系人姓名
        phone: "", //注册联系人手机号
        authCode: "", //验证码
      },
      rules: {
        contactName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
          {
            // pattern: /^[\u4e00-\u9fa5A-Za-z\s\·\(\)\（\）]+$/,
            // message: '请正确填写姓名',
            pattern: /^((?!.*(&)).)*$/,
            message: "不可输入&",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: validators.mobile,
            message: "请输入正确格式的手机号码",
            trigger: "blur",
          },
        ],

        authCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    phoneBtnClick(blcokLeft, id, callback) {
      this.getCode(blcokLeft, id, callback);
    },
    getCode(blcokLeft, id, callback) {
      getSendMsg({
        phone: this.form.phone,
        captchaVail: { x: blcokLeft, catuid: id },
      }).then((res) => {
        console.log(res, "发送短信验证码接口");
        if (res.data.code == "0") {
          callback({ data: true });
          this.isCode = false;
          this.show = false;
          let timer;
          this.isPhoneBtnClick = true;
          this.phoneBtnTxt = 60;
          timer = setInterval(() => {
            this.phoneBtnTxt = --this.phoneBtnTxt;
            if (!this.phoneBtnTxt) {
              this.isPhoneBtnClick = false;
              this.phoneBtnTxt = "发送验证码";
              clearInterval(timer);
            }
          }, 1000);
        } else {
          callback({ data: false, message: res.data.message });
          this.isCode = true;
          this.show = true;
        }
      });
    },
    // 获取滑动验证码的图片
    getImg(callback) {
      getImageVerifyCode({}).then(
        (res) => {
          callback(res.data);
        },
        (error) => {
          callback(error);
        }
      );
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(blcokLeft, id, callback) {
      // blcokLeft,// 手动定位返回的值
      //   id// 后台返回的id，再传回去
      this.phoneBtnClick(blcokLeft, id, callback); // 登陆请求方法
    },
    getTestCode() {
      this.$refs["zcform"].validateField("phone", (valid) => {
        if (!valid) {
          if (!this.isPhoneBtnClick) {
            this.isCode = true;
          }
        }
      });
    },
    submitPhone() {
      return new Promise((resolve, reject) => {
        this.$refs["zcform"].validate((valid) => {
          if (valid) {
            resolve(this.form);
            // 验证成功后，发送请求，跳转到下一步
          } else {
            reject("验证失败");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.phoneBtn {
  border-radius: 4px;
  font-size: 13px;
  width: 85px;
  font-weight: 400;
  color: #fff;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}
.phoneBtn-default {
  background-color: rgba(255, 20, 47, 1);
  &:hover {
    background: #f50b25;
  }
}
.phoneBtn-click {
  background: #cccccc;
  border: 1px solid rgba(204, 204, 204, 1);
  color: #999999;
}
.islider {
  width: 400px;
  height: 265px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px rgba(201, 201, 201, 0.5),
    4px 0px 4px 0px rgba(229, 229, 229, 0.5);
  position: absolute;
  left: 252px;
  top: -280px;
}
.islider::before {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid rgba(0, 0, 0, 0.1);
}
.islider::after {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid #ffffff;
  filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, 0.2));
}
</style>